import { render, staticRenderFns } from "./CompanyLink.vue?vue&type=template&id=d36b34d6&scoped=true&"
import script from "./CompanyLink.vue?vue&type=script&lang=js&"
export * from "./CompanyLink.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLink.vue?vue&type=style&index=0&id=d36b34d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36b34d6",
  null
  
)

export default component.exports